import styled from 'styled-components';

export const HeroContainer = styled.section`
  background: linear-gradient(rgba(0, 0, 128, 0.85), rgba(30, 144, 255, 0.85)), url('/back_imgs/header.png') no-repeat center center;
  background-size: cover;
  color: var(--light-text);
  padding: 5rem 0;
  text-align: center;
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const HeroContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const HeroTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const HeroSubtitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 400;
  margin-bottom: 3rem;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-top: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const StatItem = styled.div`
  h3 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 2rem;
    }

    p {
      font-size: 0.8rem;
    }
  }
`;